import { PriceSummaryRow } from '@ps-design-system/components/PriceSummary';
import { addDays, format, startOfWeek } from 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

export const CalendarPricingSummaryRows = ({
  calendarPricingRules,
  currency
}) => {
  return (calendarPricingRules || []).map((rule, i) => (
    <PriceSummaryRow
      key={`${rule.name}-${i}`}
      testId={`calendar-pricing-rule-${i}`}
      name={rule.name}
      description={(
        <>
          <div>
            {(rule.dows || [])
              .map((dowInteger) => {
                const date = addDays(startOfWeek(new Date()), dowInteger);
                return format(date, 'eee');
              })
              .join(', ')}
          </div>
          <div>{rule.time_interval_string}</div>
        </>
      )}
      value={(
        <FormattedMessage
          id="calendar_pricing_summary.hourly_rate"
          defaultMessage="{rate}/hr"
          values={{
            rate: (
              <FormattedNumber
                value={rule.hourly_rate || 0}
                currency={currency}
                style="currency"
                minimumFractionDigits={0}
                maximumFractionDigits={0}
              />
            )
          }}
        />
      )}
    />
  ));
};
CalendarPricingSummaryRows.displayName = 'CalendarPricingSummary';
CalendarPricingSummaryRows.propTypes = {
  calendarPricingRules: PropTypes.array,
  currency: PropTypes.string
};
